var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0-Sidebar-/-Default",
    transform: "translate(-220.000000, -854.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account",
    transform: "translate(0.000000, 828.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(220.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999996,4.49999997 C10.9910872,4.49999997 12,5.29050381 12,6.24999998 L12,7.49999997 C12,7.77614236 11.7761424,7.99999997 11.5,7.99999997 C11.2238576,7.99999997 11,7.77614236 11,7.49999997 L11,6.24999998 C11,5.90359038 10.4849013,5.49999997 9.99999996,5.49999997 L5.24999997,5.49999997 C4.83578641,5.49999997 4.49999996,5.83578641 4.49999996,6.24999998 L4.49999996,13.75 C4.49999996,14.1642136 4.83578641,14.5 5.24999997,14.5 L10.25,14.5 C10.6642136,14.5 11,14.1642136 11,13.75 L11,12.5 C11,12.2238576 11.2238576,12 11.5,12 C11.7761424,12 12,12.2238576 12,12.5 L12,13.75 C12,14.7164983 11.2164983,15.5 10.25,15.5 L5.24999997,15.5 C4.28350165,15.5 3.49999996,14.7164983 3.49999996,13.75 L3.49999996,6.24999998 C3.49999996,5.28350166 4.28350165,4.49999997 5.24999997,4.49999997 L9.99999996,4.49999997 Z M13.8535534,7.14644659 L16.3535534,9.64644661 C16.5488156,9.84170875 16.5488156,10.1582912 16.3535534,10.3535534 L13.8535534,12.8535534 C13.6582913,13.0488156 13.3417088,13.0488156 13.1464466,12.8535534 C12.9511845,12.6582913 12.9511845,12.3417088 13.1464466,12.1464466 L14.792,10.5 L7.49999998,10.5 C7.22385761,10.5 6.99999998,10.2761424 6.99999998,10 C6.99999998,9.72385762 7.22385761,9.5 7.49999998,9.5 L14.792,9.49999997 L13.1464466,7.85355338 C12.9538965,7.6610032 12.9512221,7.35047929 13.1384237,7.15465207 L13.1464466,7.14644659 C13.3417088,6.95118444 13.6582913,6.95118444 13.8535534,7.14644659 Z",
    id: "Combined-Shape",
    fill: "#666666",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.26e79a63.svg";
export { ForwardRef as ReactComponent };